import request from "../../utiles/axios";

/**
 * 登录
 * @param {*} data
 * @returns
 */
export function doLogin(data) {
  return request({
    url: "/login",
    method: "post",
    data: data,
  });
}
export function getUserInfo(data) {
  return request({
    url: "/common/loginUserInfo",
    method: "get",
    headers: {
      "token":data
    }
  });
}
/**
 * 获取菜单树
 * @param {*} data
 * @returns
*/
export function getMenuTree(data) {
  return request({
    url: "/menu/menuTree",
    method: "post",
    data: data,
  });
}

/**
 * 获取租户下拉列表
 *  
 * @returns 
 */
export function getListCompanyInfo() {
  return request({
    url: "/company/listCompanyInfo",
    method: "get",
  });
}

/**
 * 获取未审核数量
 */
export function getAuditNum() {
  return request({
    url: "/menu/auditNum",
    method: "get",
  });
}

/**
 * 修改密码
 * @param {*} data
 * @returns
 */
export function updateLoginPw(data) {
  return request({
    url: "/updatePw",
    method: "post",
    data: data,
  });
}